import {conf} from "../config";
import {getCountryFromUrl} from "../components/cookie-banner/utils";

class I18nService {

    _translations: {[key: string]: string} = {};

    async _loadTranslations(locale: string | boolean | undefined) {
        try {
            const response = await fetch(`${conf.translationServiceUrl}/${locale}/${conf.translationServiceProjectId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'GET'
                });
            if (response.ok) {
                const json = await response.json();
                for (const key in json) {
                    this._translations[key] = json[key];
                }
            }
        } catch (e) {
            console.error('error loading translations: ', e);
            return false
        }

        return true;
    }

    translate(key: string, ...replacements: string[]): string {
        if (replacements.length > 0) {
            return this.replaceWildcards(key, replacements)
        }
        return this._translations[key] ? this._translations[key] : key;
    }

    replaceWildcards(key: string, array: string[]) {
        let translation = this.translate(key);

        if (translation) {
            return translation.replace(/\$[0-9]+/g, (wildcard) => {
                const index = wildcard.match(/\d+/g);
                return index ? array[parseInt(index.toString()) - 1] : wildcard;
            });
        } else
            return key;
    }


    async initTranslations() {
        const language = getCountryFromUrl();
        return await this._loadTranslations(language);
    }
}

export const i18nService = new I18nService();